import axios from '@/axios/axios'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

// module.exports = {
//     devServer: {
//       proxy: 'http://localhost:8080'
//     }
//};

export function FileDownload(url, idx, fileName) {
    var formData = new FormData();
    formData.append("idx", idx);
    axios({
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            "Access-Control-Allow-Headers" : '*',
            "Access-Control-Allow-Methods": 'GET, POST'
        },
        data: formData,
        url: url,                 
        responseType: 'blob'
    })    
    .then(response =>{  
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    })      
}